module.exports = __webpack_public_path__ + "media/Video 56.c021ea3b.mp4";